'use client';

import React, { useEffect, useMemo } from 'react';

import { useShoppingCartContext } from '@/components/Providers/ShoppingCartProvider';
import {
  IbmPlexItalic,
  IbmPlexItalicBold,
  IbmPlexItalicMedium,
  IbmPlexItalicSemiBold,
  SweetSansPro,
  SweetSansProBold,
  SweetSansProExtraLight,
  SweetSansProLight,
  SweetSansProMedium,
  SweetSansProSemiBold,
} from '@/config/fonts';
import cn from '@/helpers/utils/classNames';

import { useStepper } from '../../Stepper';
import TrcukOneIcon from './icons/TrcukOneIcon';
import TrcukThreeIcon from './icons/TrcukThreeIcon';
import TrcukTwoIcon from './icons/TrcukTwoIcon';
import StepperContainer from './StepperContainer';

const CartFreeShippingContainer = () => {
  const { activeStep, setCurrentActiveStep, totalSteps } = useStepper(0, 3);
  const { qualifiedItemsCount } = useShoppingCartContext();

  const totalActiveSteps = useMemo(() => {
    const ezShipItems = +(qualifiedItemsCount ?? 0);

    if (ezShipItems >= totalSteps) return totalSteps;

    return ezShipItems;
  }, [qualifiedItemsCount, totalSteps]);

  useEffect(() => {
    setCurrentActiveStep(totalActiveSteps);
  }, [totalActiveSteps, setCurrentActiveStep]);

  return (
    <div
      className={cn(
        SweetSansProExtraLight.variable,
        SweetSansProLight.variable,
        SweetSansPro.variable,
        SweetSansProMedium.variable,
        SweetSansProSemiBold.variable,
        SweetSansProBold.variable,
        IbmPlexItalic.variable,
        IbmPlexItalicBold.variable,
        IbmPlexItalicMedium.variable,
        IbmPlexItalicSemiBold.variable,
        'v2-mb-10'
      )}
    >
      <StepperContainer activeStep={activeStep} totalSteps={totalSteps}>
        <StepperContainer.Step
          icon={(isStepActive: boolean) => <TrcukOneIcon fill={isStepActive ? '#154734' : '#98A2B3'} />}
        />
        <StepperContainer.Step
          icon={(isStepActive: boolean) => (
            <div className="v2-flex v2-justify-center">
              <TrcukTwoIcon fill={isStepActive ? '#154734' : '#98A2B3'} />
            </div>
          )}
        />
        <StepperContainer.Step
          icon={(isStepActive: boolean) => (
            <div className="v2-flex v2-justify-end">
              <TrcukThreeIcon fill={isStepActive ? '#154734' : '#98A2B3'} />
            </div>
          )}
        />
      </StepperContainer>
    </div>
  );
};

export default CartFreeShippingContainer;
